import { Controller } from "@hotwired/stimulus"

// Toggles a small explanation panel next to its trigger button.
//
// Unlike calendar_popover_controller, the panel is already in the DOM next to
// the button — there is nothing to clone and nothing to position, so this stays
// tiny. Closes on outside click and on Escape.
//
// Not named "popover": that identifier belongs to tailwindcss-stimulus-components
// (registered in application.js), whose show/hide the hover tooltips across the
// app call. Registering a second "popover" silently replaces it.
export default class extends Controller {
  static targets = ["panel", "button"]

  connect() {
    this.onDocumentClick = this.handleDocumentClick.bind(this)
    this.onKeydown = this.handleKeydown.bind(this)
    document.addEventListener("click", this.onDocumentClick)
    document.addEventListener("keydown", this.onKeydown)
  }

  disconnect() {
    document.removeEventListener("click", this.onDocumentClick)
    document.removeEventListener("keydown", this.onKeydown)
  }

  toggle(event) {
    event.preventDefault()
    event.stopPropagation()
    if (!this.hasPanelTarget) return

    const willOpen = this.panelTarget.classList.contains("hidden")
    this.panelTarget.classList.toggle("hidden", !willOpen)
    if (this.hasButtonTarget) {
      this.buttonTarget.setAttribute("aria-expanded", String(willOpen))
    }
  }

  hide() {
    if (!this.hasPanelTarget || this.panelTarget.classList.contains("hidden")) return
    this.panelTarget.classList.add("hidden")
    if (this.hasButtonTarget) this.buttonTarget.setAttribute("aria-expanded", "false")
  }

  handleDocumentClick(event) {
    if (this.element.contains(event.target)) return
    this.hide()
  }

  handleKeydown(event) {
    if (event.key === "Escape") this.hide()
  }
}
